import styled from 'styled-components';
import {device} from './responsives.js';

export const Title = styled.p`
  display: inline-block;
  font-size: ${props => (props.title ? "32px" : "24px")};
  text-align: left;
  vertical-align: center;
  margin: 0px 20px 0px 0px
  font-family: Avenir;
  font-weight: 900;
  cursor: ${props => (props.title ? "default" : "pointer")}
`

export const EntityMenuBtn = styled.button`
  display: inline-block;
  height: 40px;
  width: 55px;
  border: #ffffff;
  margin-left: 16px;
  margin-right: 20px;
  padding: 0px 12px;
  font-family: Avenir;
  -webkit-appearance: none;
  background: linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83));
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2)
  position: relative;
  top: 50%;
  transform: translateY(50%);
  -ms-transform: translateY(50%);
  @media ${device.tablet}{
    top: 50%;
    transform: translateY(7%);
    -ms-transform: translateY(7%);
    margin-right: 0px;
  }
`

export const Modal = styled.div`
  position: fixed;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  padding: 24px 8px;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 1;
  visibility: ${props => (props.visible ? "visible" : "hidden")};
`

export const EntityUl = styled.ul`
  position: relative;
  cursor: pointer;
  top: 20%;
  left: 5%;
  background: #ffffff;
  display: block;
  width: 60%;
  height: 250px
  border-radius: 5px;
  border: black;
  overflow: scroll;
  visibility: ${props => (props.visible ? "visible" : "hidden")};
  @media ${device.ipadPro}{
    width: 80%;
  }
  @media ${device.tablet}{
    height: 300px;
    top: 10%;
    left: 3%;
    width: 90%;
    padding-top: 12px;
  }
`

export const EntityBarCont = styled.li`
  display: ${props => (props.title ? "inline-block" : "block")};
  list-style-position: ${props => (!props.title ? "inside" : "none")};
  background: ${props => (props.title ? "#ffffff" : "transparent")}
  vertical-align: center;
  padding: ${props => (props.title ? "0px 8px" : "8px")};
  position: ${props => (props.title ? "relative" : "none")};
  top: 50%;
  transform: ${props => (props.title ? "translateY(-50%)" : "translateY(0%)")};
  -ms-transform: ${props => (props.title ? "translateY(-50%)" : "translateY(0%)")};
`

export const DropImg = styled.img`
  display: inline-block;
  width: 100%;
  object-fit: cover;
  vertical-align: center;
  padding: 0px;
`

export const Meta = styled.div`
  display: inline-block;
  vertical-align: top;
  border-radius: 6px;
  background-color: #F4F8FB;
  height: ${props => (props.title ? "40px" : "30px")};
  width: auto;
  padding: 4px 8px;
`

export const MetaIcon = styled.img`
  height: ${props => (props.title ? "28px" : "22px")};
  width: ${props => (props.title ? "28px" : "22px")};
  margin: 0px 4px 0px 16px;
  display: inline-block;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
`

export const RateDiv = styled.div`
  display: inline-block;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
`

export const MetaCount = styled.p`
  display: inline-block;
  font-size: 16px;
  margin: 0px 8px;
  position: relative;
  top: 40%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
`
